import { z } from "zod";

export const OfferProductMetafieldSchema = z.object({
  ownerId: z.string(),
  include: z.string().array().optional(),
  exclude: z.string().array().optional(),
});

export type OfferProductMetafield =
  | OfferProductMetafieldPayload
  | {
      include?: string[];
      exclude?: string[];
    };

export interface OfferProductMetafieldPayload {
  ownerId: string;
  include: string[];
  exclude: string[];
}

export interface OfferMetafieldsSyncOptions {
  dryRun?: boolean;
  mode?: "products" | "discounts";
  emitWebsocket?: boolean;
}
